import { render, staticRenderFns } from "./NewStoreTitlebar.vue?vue&type=template&id=043d63bd&scoped=true"
import script from "./NewStoreTitlebar.vue?vue&type=script&lang=js"
export * from "./NewStoreTitlebar.vue?vue&type=script&lang=js"
import style0 from "./NewStoreTitlebar.vue?vue&type=style&index=0&id=043d63bd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "043d63bd",
  null
  
)

export default component.exports